import { render, staticRenderFns } from "./RegulatoryUpdateAddressSummary.vue?vue&type=template&id=687579de&scoped=true"
import script from "./RegulatoryUpdateAddressSummary.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateAddressSummary.vue?vue&type=script&lang=ts"
import style0 from "./RegulatoryUpdateAddressSummary.vue?vue&type=style&index=0&id=687579de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687579de",
  null
  
)

export default component.exports